import { addDays, startOfWeek } from 'date-fns';
import type { Weekday } from '../../../common/business-hours-types';
import type { SettingsWeek } from '../settings-week/settings-week';
import { formatRegularDay } from './format-regular-day';
import type { RegularWeek } from './regular-week';

export function getWeekFromFirst(
  settingsWeek: SettingsWeek,
  firstWeekday: Weekday
): RegularWeek {
  const now = new Date();
  const startingIndex =
    settingsWeek.find(({ weekday }) => weekday === firstWeekday)
      ?.weekdayIndex || 0;
  const startDate = startOfWeek(now, {
    weekStartsOn: startingIndex as 0 | 1 | 2 | 3 | 4 | 5 | 6
  });

  return settingsWeek
    .sort((a, b) => {
      const orderA = (a.weekdayIndex - startingIndex + 7) % 7;
      const orderB = (b.weekdayIndex - startingIndex + 7) % 7;
      return orderA - orderB;
    })
    .map((day, index) => {
      const date = addDays(startDate, index);
      return formatRegularDay(day, date, now, false);
    });
}
